import { useEffect } from 'react'
import OnboardingChat from '../components/OnboardingChat'
import './Dashboard.css'

export default function Dashboard() {
  useEffect(() => {
    document.title = 'Replay QA'
  }, [])

  // Onboarding is a guided chat that starts from a URL and ends at createProject → the project
  // overview.
  return (
    <div className="dashboard" data-testid="dashboard-page">
      <OnboardingChat />
    </div>
  )
}
